module.exports = __webpack_public_path__ + "img/rku10-char-1.1a08e36f.png";